import { createSelector } from 'reselect'

export const getElements = createSelector(
  state => state && state.user && state.user.listSidebar && state.user.listSidebar.elements ?
    state.user.listSidebar.elements : null,
  elements => elements
)
